export default __webpack_public_path__ + "static/media/TalkingTimber.80aedfd8.jpg";